import type { JobsJobElasticSchemaWithId } from '@iconik-io/iconik-api/src/services/jobs';

import { handleWebsocketMessages } from '../../ducks/jobs/thunks';
import { useAppDispatch } from '../../store/react_redux_typed';
import { WebsocketManagerWeb } from '../websocket_manager_web/websocket_manager_web';

type Props = {
  job?: JobsJobElasticSchemaWithId;
  jobs?: JobsJobElasticSchemaWithId[];
};

function WebSocketJobs({ job, jobs = [] }: Props) {
  const dispatch = useAppDispatch();

  return job ? (
    <WebsocketManagerWeb
      pathEntity="jobs"
      objectId={job.id}
      onJobEntityMessage={(message) =>
        dispatch(handleWebsocketMessages(message))
      }
    />
  ) : (
    jobs.map((item) => (
      <WebsocketManagerWeb key={item.id} pathEntity="jobs" objectId={item.id} />
    ))
  );
}

export default WebSocketJobs;
